import { injectIntl } from 'react-intl';
import { compose } from 'redux';
import { connect } from 'react-redux';

// Components
import TermsPrivacy from './TermsPrivacy';

// Selectors
import { getAppName } from 'store/reducers/userInteractions/selectors';

const mapStateToProps = state => ({
  appName: getAppName(state)
});

export default compose(
  injectIntl,
  connect(
    mapStateToProps,
    {}
  )
)(TermsPrivacy);



// WEBPACK FOOTER //
// ./src/components/pages/components/ContentFooter/components/TermsPrivacy/TermsPrivacyContainer.js